import { render, staticRenderFns } from "./messageArea.vue?vue&type=template&id=a3cf00d0&scoped=true&"
import script from "./messageArea.vue?vue&type=script&lang=js&"
export * from "./messageArea.vue?vue&type=script&lang=js&"
import style0 from "./messageArea.vue?vue&type=style&index=0&id=a3cf00d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cf00d0",
  null
  
)

export default component.exports